<script lang="ts">
	import { getTranslate } from "../utils/getTranslate.js";
	import Link from "./Link.svelte";
	import translations from "./HomepageSoftware.translations.json";
	import arrowRight from "../../../core/assets/icons/arrow-right.svg?raw";
	import { aboutPathMap } from "../../../core/schema/paths/aboutPathMap.js";
	import { getTenant } from "../getTenant.js";
	import ComputerSection from "./ComputerSection.svelte";

	const translate = getTranslate(translations);
	const tenant = getTenant();
</script>

<ComputerSection>
	<h2 class="text-ltprimary m-0 mb-8 p-0 uppercase tracking-[0.02em]">
		{translate("headline")}
	</h2>
	<div class="lg:text-md/normal mx-auto mb-5 tracking-[0.02em]">
		{translate("paragraph1")}
	</div>
	<div class="lg:text-md/normal mx-auto mb-5 tracking-[0.02em]">
		{translate("paragraph2")}
	</div>
	<div class="mt-3 flex lg:mt-8 xl:mt-11">
		<Link asButton variant="secondary" icon={arrowRight} href="/{aboutPathMap[tenant.locale]}">
			{translate("ourSoftwareSolution")}
		</Link>
	</div>
</ComputerSection>
